import { useEffect, useState } from 'react';

import { Spectrum } from '../contexts/SpectrumProvider';

function getMediaQuery() {
  if (typeof window === 'undefined') {
    return undefined;
  }
  try {
    return window.matchMedia('(prefers-color-scheme: dark)');
  } catch {
    return undefined;
  }
}

export function useSystemPreference() {
  const mediaQuery = getMediaQuery();
  const [systemPreference, setSystemPreference] = useState<Spectrum>(
    mediaQuery?.matches ? 'dark' : 'light',
  );

  useEffect(() => {
    if (!mediaQuery) {
      return undefined;
    }

    const listener = ({ matches }: { matches: boolean }) => {
      if (matches) {
        setSystemPreference('dark');
      } else {
        setSystemPreference('light');
      }
    };
    mediaQuery.addEventListener('change', listener);
    return () => {
      mediaQuery.removeEventListener('change', listener);
    };
  }, [mediaQuery]);

  return systemPreference;
}
